import { toggleSelectPlaceholderState } from "./utils/select-utils";

document.addEventListener("DOMContentLoaded", function () {
  toggleSelectPlaceholderState();

  $(".custom-select").on("change", () => {
    toggleSelectPlaceholderState();
  });
});
